const state = {
  isOpen: false,
  data: {},
};

const getters = {
  GetIsOpenBanner: (state) => {
    return state.isOpen;
  },
  GetDataBanner: (state) => {
    return state.data;
  },
};
export { state, getters };
